import type { TechnicalFeatures } from './technical-features-get-api';

export interface TechFeatureSubmitApiRequest {
    task_id: string;
    tech_features: TechnicalFeatures[];
}

export type TechFeatureSubmitApiResponse = void;

/**
 * 技术特征提交 API
 */
export interface TechFeatureSubmitApi {
    /**
     * 提交技术特征
     */
    submitTechFeature(data: TechFeatureSubmitApiRequest): Promise<TechFeatureSubmitApiResponse>;
}

export const TechFeatureSubmitApi = Symbol.for('TechFeatureSubmitApi');
